import Service from '@ember/service';
import { getApiBaseUrl } from 'frontend-payments/utils/api-config';
import { throwApiError } from 'frontend-payments/utils/api-helpers';

export interface LoginRequest {
  email: string;
}

export interface LoginVerificationRequest {
  email: string;
  totp_code: string;
}

export default class AuthService extends Service {
  /**
   * Requests a TOTP code to be sent to the user's email
   * Throws structured errors on failure
   */
  async requestTotpCode(email: string): Promise<void> {
    const response = await fetch(`${getApiBaseUrl()}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email } as LoginRequest),
    });

    if (!response.ok) {
      await throwApiError(response);
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    auth: AuthService;
  }
}
